import datapoints_international from "ressources/data/datapoints_international.json"
import datapoints_default from "ressources/data/datapoints.json"
import effects from "ressources/data/effects.json"
import drugs_international from "ressources/data/drugs_international.json"
import drugs_default from "ressources/data/drugs.json"
import drug_info from "ressources/data/drug_info.json"

function getDatapoint(drug, effect) {
	let datapoints

	if (process.env.REACT_APP_MODE === "STANDALONE") {
		datapoints = datapoints_international
	} else {
		datapoints = datapoints_default
	}
	return datapoints[drug][effect]
}

function getEffects() {
	return ["EFFICACY", ...[...effects.included, ...effects.excluded].sort().filter(e => e !== "EFFICACY")]
}

function getDrugs() {
	let drugs

	if (process.env.REACT_APP_MODE === "STANDALONE") {
		drugs = drugs_international
	} else {
		drugs = drugs_default
	}

	return [...drugs.included, ...drugs.excluded].sort()
}

function getParagraphKeys(drug) {
	const keys = drug_info[drug];
	//const translations = keys.map(key => i18n.t(key));
	//return translations.length ? translations : null;
	return keys.length ? keys : null;
}

export const dataService = {
	getDatapoint: getDatapoint,
	getDrugs: getDrugs,
	getEffects,
	getParagraphKeys
}
